import { render } from "./index.vue?vue&type=template&id=df389ae6&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=df389ae6&lang=less&scoped=true"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df389ae6"]])

export default __exports__